function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isArray, isNumber } from 'vega-util';
import { isBinned, isBinning, isBinParams } from '../../../bin';
import { getOffsetChannel, getSecondaryRangeChannel, getSizeChannel, getVgPositionChannel, isPolarPositionChannel, isXorY } from '../../../channel';
import { getBandPosition, getBandSize, isFieldDef, isFieldOrDatumDef, vgField } from '../../../channeldef';
import { getViewConfigDiscreteStep } from '../../../config';
import * as log from '../../../log';
import { isRelativeBandSize } from '../../../mark';
import { hasDiscreteDomain } from '../../../scale';
import { isSignalRef, isVgRangeStep } from '../../../vega.schema';
import { getMarkConfig, getMarkPropOrConfig, signalOrStringValue, signalOrValueRef } from '../../common';
import { nonPosition } from './nonposition';
import { positionOffset } from './offset';
import { vgAlignedPositionChannel } from './position-align';
import { pointPositionDefaultRef } from './position-point';
import { rangePosition } from './position-range';
import * as ref from './valueref';
import { getOffsetScaleChannel } from '../../../channel';
import { getFirstDefined } from '../../../util';
import { OFFSETTED_RECT_END_SUFFIX, OFFSETTED_RECT_START_SUFFIX } from '../../data/timeunit';
export function rectPosition(model, channel) {
  var _ref, _encoding$sizeChannel;
  var config = model.config,
    encoding = model.encoding,
    markDef = model.markDef;
  var mark = markDef.type;
  var channel2 = getSecondaryRangeChannel(channel);
  var sizeChannel = getSizeChannel(channel);
  var channelDef = encoding[channel];
  var channelDef2 = encoding[channel2];
  var scale = model.getScaleComponent(channel);
  var scaleType = scale ? scale.get('type') : undefined;
  var orient = markDef.orient;
  var hasSizeDef = (_ref = (_encoding$sizeChannel = encoding[sizeChannel]) !== null && _encoding$sizeChannel !== void 0 ? _encoding$sizeChannel : encoding.size) !== null && _ref !== void 0 ? _ref : getMarkPropOrConfig('size', markDef, config, {
    vgChannel: sizeChannel
  });
  var offsetScaleChannel = getOffsetChannel(channel);
  var isBarOrTickBand = mark === 'bar' && (channel === 'x' ? orient === 'vertical' : orient === 'horizontal') || mark === 'tick' && (channel === 'y' ? orient === 'vertical' : orient === 'horizontal');
  // x, x2, and width -- we must specify two of these in all conditions
  if (isFieldDef(channelDef) && (isBinning(channelDef.bin) || isBinned(channelDef.bin) || channelDef.timeUnit && !channelDef2) && !(hasSizeDef && !isRelativeBandSize(hasSizeDef)) && !encoding[offsetScaleChannel] && !hasDiscreteDomain(scaleType)) {
    return rectBinPosition({
      fieldDef: channelDef,
      fieldDef2: channelDef2,
      channel: channel,
      model: model
    });
  } else if ((isFieldOrDatumDef(channelDef) && hasDiscreteDomain(scaleType) || isBarOrTickBand) && !channelDef2) {
    return positionAndSize(channelDef, channel, model);
  } else {
    return rangePosition(channel, model, {
      defaultPos: 'zeroOrMax',
      defaultPos2: 'zeroOrMin'
    });
  }
}
function defaultSizeRef(sizeChannel, scaleName, scale, config, bandSize, hasFieldDef, mark) {
  if (isRelativeBandSize(bandSize)) {
    if (scale) {
      var scaleType = scale.get('type');
      if (scaleType === 'band') {
        var bandWidth = "bandwidth('".concat(scaleName, "')");
        if (bandSize.band !== 1) {
          bandWidth = "".concat(bandSize.band, " * ").concat(bandWidth);
        }
        var minBandSize = getMarkConfig('minBandSize', {
          type: mark
        }, config);
        return {
          signal: minBandSize ? "max(".concat(signalOrStringValue(minBandSize), ", ").concat(bandWidth, ")") : bandWidth
        };
      } else if (bandSize.band !== 1) {
        log.warn(log.message.cannotUseRelativeBandSizeWithNonBandScale(scaleType));
        bandSize = undefined;
      }
    } else {
      return {
        mult: bandSize.band,
        field: {
          group: sizeChannel
        }
      };
    }
  } else if (isSignalRef(bandSize)) {
    return bandSize;
  } else if (bandSize) {
    return {
      value: bandSize
    };
  }
  // no valid band size
  if (scale) {
    var scaleRange = scale.get('range');
    if (isVgRangeStep(scaleRange) && isNumber(scaleRange.step)) {
      return {
        value: scaleRange.step - 2
      };
    }
  }
  if (!hasFieldDef) {
    var _config$scale = config.scale,
      bandPaddingInner = _config$scale.bandPaddingInner,
      barBandPaddingInner = _config$scale.barBandPaddingInner,
      rectBandPaddingInner = _config$scale.rectBandPaddingInner,
      tickBandPaddingInner = _config$scale.tickBandPaddingInner;
    var padding = getFirstDefined(bandPaddingInner, mark === 'tick' ? tickBandPaddingInner : mark === 'bar' ? barBandPaddingInner : rectBandPaddingInner); // this part is like paddingInner in scale.ts
    if (isSignalRef(padding)) {
      return {
        signal: "(1 - (".concat(padding.signal, ")) * ").concat(sizeChannel)
      };
    } else if (isNumber(padding)) {
      return {
        signal: "".concat(1 - padding, " * ").concat(sizeChannel)
      };
    }
  }
  var defaultStep = getViewConfigDiscreteStep(config.view, sizeChannel);
  return {
    value: defaultStep - 2
  };
}
/**
 * Output position encoding and its size encoding for continuous, point, and band scales.
 */
function positionAndSize(fieldDef, channel, model) {
  var _ref2, _ref4;
  var markDef = model.markDef,
    encoding = model.encoding,
    config = model.config,
    stack = model.stack;
  var orient = markDef.orient;
  var scaleName = model.scaleName(channel);
  var scale = model.getScaleComponent(channel);
  var vgSizeChannel = getSizeChannel(channel);
  var channel2 = getSecondaryRangeChannel(channel);
  var offsetScaleChannel = getOffsetChannel(channel);
  var offsetScaleName = model.scaleName(offsetScaleChannel);
  var offsetScale = model.getScaleComponent(getOffsetScaleChannel(channel));
  var useVlSizeChannel =
  // Always uses size channel for ticks, because tick only calls rectPosition() for the size channel
  markDef.type === 'tick' ||
  // use "size" channel for bars, if there is orient and the channel matches the right orientation
  orient === 'horizontal' && channel === 'y' || orient === 'vertical' && channel === 'x';
  // Use size encoding / mark property / config if it exists
  var sizeMixins;
  if (encoding.size || markDef.size) {
    if (useVlSizeChannel) {
      sizeMixins = nonPosition('size', model, {
        vgChannel: vgSizeChannel,
        defaultRef: signalOrValueRef(markDef.size)
      });
    } else {
      log.warn(log.message.cannotApplySizeToNonOrientedMark(markDef.type));
    }
  }
  var hasSizeFromMarkOrEncoding = !!sizeMixins;
  // Otherwise, apply default value
  var bandSize = getBandSize({
    channel: channel,
    fieldDef: fieldDef,
    markDef: markDef,
    config: config,
    scaleType: (_ref2 = scale || offsetScale) === null || _ref2 === void 0 ? void 0 : _ref2.get('type'),
    useVlSizeChannel: useVlSizeChannel
  });
  sizeMixins = sizeMixins || _defineProperty({}, vgSizeChannel, defaultSizeRef(vgSizeChannel, offsetScaleName || scaleName, offsetScale || scale, config, bandSize, !!fieldDef, markDef.type));
  /*
    Band scales with size value and all point scales, use xc/yc + band=0.5
       Otherwise (band scales that has size based on a band ref), use x/y with position band = (1 - size_band) / 2.
    In this case, size_band is the band specified in the x/y-encoding.
    By default band is 1, so `(1 - band) / 2` = 0.
    If band is 0.6, the the x/y position in such case should be `(1 - band) / 2` = 0.2
   */
  var defaultBandAlign = ((_ref4 = scale || offsetScale) === null || _ref4 === void 0 ? void 0 : _ref4.get('type')) === 'band' && isRelativeBandSize(bandSize) && !hasSizeFromMarkOrEncoding ? 'top' : 'middle';
  var vgChannel = vgAlignedPositionChannel(channel, markDef, config, defaultBandAlign);
  var center = vgChannel === 'xc' || vgChannel === 'yc';
  var _positionOffset = positionOffset({
      channel: channel,
      markDef: markDef,
      encoding: encoding,
      model: model,
      bandPosition: center ? 0.5 : 0
    }),
    offset = _positionOffset.offset,
    offsetType = _positionOffset.offsetType;
  var posRef = ref.midPointRefWithPositionInvalidTest({
    channel: channel,
    channelDef: fieldDef,
    markDef: markDef,
    config: config,
    scaleName: scaleName,
    scale: scale,
    stack: stack,
    offset: offset,
    defaultRef: pointPositionDefaultRef({
      model: model,
      defaultPos: 'mid',
      channel: channel,
      scaleName: scaleName,
      scale: scale
    }),
    bandPosition: center ? offsetType === 'encoding' ? 0 : 0.5 : isSignalRef(bandSize) ? {
      signal: "(1-".concat(bandSize, ")/2")
    } : isRelativeBandSize(bandSize) ? (1 - bandSize.band) / 2 : 0
  });
  if (vgSizeChannel) {
    return _objectSpread(_defineProperty({}, vgChannel, posRef), sizeMixins);
  } else {
    // otherwise, we must simulate size by setting position2 = position + size
    // (for theta/radius since Vega doesn't have thetaWidth/radiusWidth)
    var vgChannel2 = getVgPositionChannel(channel2);
    var sizeRef = sizeMixins[vgSizeChannel];
    var sizeOffset = offset ? _objectSpread(_objectSpread({}, sizeRef), {}, {
      offset: offset
    }) : sizeRef;
    return _defineProperty(_defineProperty({}, vgChannel, posRef), vgChannel2, isArray(posRef) ? [posRef[0], _objectSpread(_objectSpread({}, posRef[1]), {}, {
      offset: sizeOffset
    })] : _objectSpread(_objectSpread({}, posRef), {}, {
      offset: sizeOffset
    }));
  }
}
function getBinSpacing(channel, spacing, reverse, axisTranslate, offset, minBandSize, bandSizeExpr) {
  if (isPolarPositionChannel(channel)) {
    return 0;
  }
  var isEnd = channel === 'x' || channel === 'y2';
  var spacingOffset = isEnd ? -spacing / 2 : spacing / 2;
  if (isSignalRef(reverse) || isSignalRef(offset) || isSignalRef(axisTranslate) || minBandSize) {
    var reverseExpr = signalOrStringValue(reverse);
    var offsetExpr = signalOrStringValue(offset);
    var axisTranslateExpr = signalOrStringValue(axisTranslate);
    var minBandSizeExpr = signalOrStringValue(minBandSize);
    var sign = isEnd ? '' : '-';
    var spacingAndSizeOffset = minBandSize ? "(".concat(bandSizeExpr, " < ").concat(minBandSizeExpr, " ? ").concat(sign, "0.5 * (").concat(minBandSizeExpr, " - (").concat(bandSizeExpr, ")) : ").concat(spacingOffset, ")") : spacingOffset;
    var t = axisTranslateExpr ? "".concat(axisTranslateExpr, " + ") : '';
    var r = reverseExpr ? "(".concat(reverseExpr, " ? -1 : 1) * ") : '';
    var o = offsetExpr ? "(".concat(offsetExpr, " + ").concat(spacingAndSizeOffset, ")") : spacingAndSizeOffset;
    return {
      signal: t + r + o
    };
  } else {
    offset = offset || 0;
    return axisTranslate + (reverse ? -offset - spacingOffset : +offset + spacingOffset);
  }
}
function rectBinPosition(_ref6) {
  var _model$component$axes, _axis$get, _getMarkPropOrConfig;
  var fieldDef = _ref6.fieldDef,
    fieldDef2 = _ref6.fieldDef2,
    channel = _ref6.channel,
    model = _ref6.model;
  var config = model.config,
    markDef = model.markDef,
    encoding = model.encoding;
  var scale = model.getScaleComponent(channel);
  var scaleName = model.scaleName(channel);
  var scaleType = scale ? scale.get('type') : undefined;
  var reverse = scale.get('reverse');
  var bandSize = getBandSize({
    channel: channel,
    fieldDef: fieldDef,
    markDef: markDef,
    config: config,
    scaleType: scaleType
  });
  var axis = (_model$component$axes = model.component.axes[channel]) === null || _model$component$axes === void 0 ? void 0 : _model$component$axes[0];
  var axisTranslate = (_axis$get = axis === null || axis === void 0 ? void 0 : axis.get('translate')) !== null && _axis$get !== void 0 ? _axis$get : 0.5; // vega default is 0.5
  var spacing = isXorY(channel) ? (_getMarkPropOrConfig = getMarkPropOrConfig('binSpacing', markDef, config)) !== null && _getMarkPropOrConfig !== void 0 ? _getMarkPropOrConfig : 0 : 0;
  var channel2 = getSecondaryRangeChannel(channel);
  var vgChannel = getVgPositionChannel(channel);
  var vgChannel2 = getVgPositionChannel(channel2);
  var minBandSize = getMarkConfig('minBandSize', markDef, config);
  var _positionOffset2 = positionOffset({
      channel: channel,
      markDef: markDef,
      encoding: encoding,
      model: model,
      bandPosition: 0
    }),
    offset = _positionOffset2.offset;
  var _positionOffset3 = positionOffset({
      channel: channel2,
      markDef: markDef,
      encoding: encoding,
      model: model,
      bandPosition: 0
    }),
    offset2 = _positionOffset3.offset;
  var bandSizeExpr = ref.binSizeExpr({
    fieldDef: fieldDef,
    scaleName: scaleName
  });
  var binSpacingOffset = getBinSpacing(channel, spacing, reverse, axisTranslate, offset, minBandSize, bandSizeExpr);
  var binSpacingOffset2 = getBinSpacing(channel2, spacing, reverse, axisTranslate, offset2 !== null && offset2 !== void 0 ? offset2 : offset, minBandSize, bandSizeExpr);
  var bandPositionForBandSize = isSignalRef(bandSize) ? {
    signal: "(1-".concat(bandSize.signal, ")/2")
  } : isRelativeBandSize(bandSize) ? (1 - bandSize.band) / 2 : 0.5;
  var bandPosition = getBandPosition({
    fieldDef: fieldDef,
    fieldDef2: fieldDef2,
    markDef: markDef,
    config: config
  });
  if (isBinning(fieldDef.bin) || fieldDef.timeUnit) {
    var useRectOffsetField = fieldDef.timeUnit && bandPosition !== 0.5;
    return _defineProperty(_defineProperty({}, vgChannel2, rectBinRef({
      fieldDef: fieldDef,
      scaleName: scaleName,
      bandPosition: bandPositionForBandSize,
      offset: binSpacingOffset2,
      useRectOffsetField: useRectOffsetField
    })), vgChannel, rectBinRef({
      fieldDef: fieldDef,
      scaleName: scaleName,
      bandPosition: isSignalRef(bandPositionForBandSize) ? {
        signal: "1-".concat(bandPositionForBandSize.signal)
      } : 1 - bandPositionForBandSize,
      offset: binSpacingOffset,
      useRectOffsetField: useRectOffsetField
    }));
  } else if (isBinned(fieldDef.bin)) {
    var startRef = ref.valueRefForFieldOrDatumDef(fieldDef, scaleName, {}, {
      offset: binSpacingOffset2
    });
    if (isFieldDef(fieldDef2)) {
      return _defineProperty(_defineProperty({}, vgChannel2, startRef), vgChannel, ref.valueRefForFieldOrDatumDef(fieldDef2, scaleName, {}, {
        offset: binSpacingOffset
      }));
    } else if (isBinParams(fieldDef.bin) && fieldDef.bin.step) {
      return _defineProperty(_defineProperty({}, vgChannel2, startRef), vgChannel, {
        signal: "scale(\"".concat(scaleName, "\", ").concat(vgField(fieldDef, {
          expr: 'datum'
        }), " + ").concat(fieldDef.bin.step, ")"),
        offset: binSpacingOffset
      });
    }
  }
  log.warn(log.message.channelRequiredForBinned(channel2));
  return undefined;
}
/**
 * Value Ref for binned fields
 */
function rectBinRef(_ref10) {
  var fieldDef = _ref10.fieldDef,
    scaleName = _ref10.scaleName,
    bandPosition = _ref10.bandPosition,
    offset = _ref10.offset,
    useRectOffsetField = _ref10.useRectOffsetField;
  return ref.interpolatedSignalRef(_objectSpread({
    scaleName: scaleName,
    fieldOrDatumDef: fieldDef,
    bandPosition: bandPosition,
    offset: offset
  }, useRectOffsetField ? {
    startSuffix: OFFSETTED_RECT_START_SUFFIX,
    endSuffix: OFFSETTED_RECT_END_SUFFIX
  } : {}));
}